
  import { Component, Vue, Prop } from 'vue-property-decorator';
  import {IApp} from "@/interfaces/app.interface";
  import ROUTE_NAME = IApp.ROUTE_NAME;
  import {IAuth} from "@/modules/Auth/interfaces/auth.interface";

  @Component({})
  export default class RegistrationResult extends Vue {
    @Prop() formData: IAuth.DataRegistration;

    get message() {
      let text = '';
      if (this.formData.email && !this.formData.phone) {
        text = 'На Вашу почту отправлено письмо с паролем.';
      }
      else if (!this.formData.email && this.formData.phone) {
        text = 'На Ваш телефон отправлено сообщение с паролем.';
      }
      else {
        text = 'На Ваш телефон и почту отправлено сообщение с паролем.';
      }
      return text;
    }

    goToAuth() {
      const { query } = this.$route;
      query.login = this.formData.phone || this.formData.email;
      this.$router.push({ name: ROUTE_NAME.PAGE_AUTHORIZATION, query });
    }
  }
